import {buildChildrenMap, isRootGroup} from "@/utils/productGroupTree";

function orderValue(item) {
    return item?.orderIndex > 0 ? item.orderIndex : Number.MAX_SAFE_INTEGER;
}

function inheritedFirst(a, b, isInherited) {
    return isInherited ? Number(isInherited(b)) - Number(isInherited(a)) : 0;
}

export function sortByOrderIndex(list, isInherited = null) {
    return [...(list || [])].sort((a, b) => orderValue(a) - orderValue(b) || inheritedFirst(a, b, isInherited));
}

export function productGroupIdOf(product) {
    return product?.productGroupId ?? product?.productGroup?.productGroupId ?? null;
}

export function countProductsByGroup(products) {
    const counts = {};
    (products || []).forEach(product => {
        const id = productGroupIdOf(product);
        counts[id] = (counts[id] || 0) + 1;
    });
    return counts;
}

export function groupProductsByGroup(products) {
    const map = {};
    sortByOrderIndex(products).forEach(product => {
        const id = productGroupIdOf(product);
        if (id === null) return;
        (map[id] = map[id] || []).push(product);
    });
    return map;
}

export function sortedChildrenMap(groups, isInherited = null) {
    const map = buildChildrenMap(groups);
    Object.keys(map).forEach(key => {
        map[key] = sortByOrderIndex(map[key], isInherited);
    });
    return map;
}

export function withDescendantIds(groups, ids) {
    const childrenMap = buildChildrenMap(groups);
    const result = new Set();
    const pending = (ids || []).map(id => String(id));
    while (pending.length) {
        const id = pending.pop();
        if (result.has(id)) continue;
        result.add(id);
        (childrenMap[id] || []).forEach(child => pending.push(String(child.productGroupId)));
    }
    return result;
}

export function parentGroupOptions(groups, excludedIds) {
    const excluded = withDescendantIds(groups, excludedIds);
    return (groups || []).filter(group => !excluded.has(String(group.productGroupId)));
}

export function rootGroupsOf(groups) {
    return sortByOrderIndex((groups || []).filter(group => isRootGroup(group)));
}

